/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: validators.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Validation functions for User Profile form.

 🔁 Last Updated: 2025-01-XX by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import type { UserProfileData, ProfileFormErrors } from '../types';

/**
 * Email validation regex
 */
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validate email format
 */
export function validateEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

/**
 * Validate user profile form
 */
export function validateUserProfile(
  formData: UserProfileData,
  t: (key: string) => string
): ProfileFormErrors {
  const errors: ProfileFormErrors = {};

  if (!formData.email.trim()) {
    errors.email = t('profile.errors.emailRequired');
  } else if (!validateEmail(formData.email)) {
    errors.email = t('profile.errors.emailInvalid');
  }

  return errors;
}

/**
 * Check if form is valid
 */
export function isFormValid(errors: ProfileFormErrors): boolean {
  return Object.keys(errors).length === 0;
}

